import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import { Box, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Alert, CircularProgress } from '@mui/material';
import Menu from '../components/Menu';
import api from '../utils/apiClient';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const fmtDateTime = (iso) => {
  const d = new Date(iso);
  const p = (n) => String(n).padStart(2, '0');
  return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
};
const fmtInt = (n) => Math.round(Number(n) || 0).toLocaleString('ru-RU');

// Журнал сбоев мониторинга: окна, когда данные не записывались по нашей причине. Часы работы за такое окно
// досчитываются асикам по их доле работы, аптайм окно не учитывает.
const Outages = () => {
  const { t } = useTranslation('menu');
  const theme = useTheme();
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api.get(`${API_BASE_URL}monitoring_outages`)
      .then((resp) => { if (!cancelled) setRows(resp?.data?.outages || []); })
      .catch(() => { if (!cancelled) setError(true); });
    return () => { cancelled = true; };
  }, []);

  const num = { textAlign: 'right', whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' };

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: theme.palette.background.default }}>
      <Menu hideRefresh />
      <Box sx={{ maxWidth: 1200, mx: 'auto', px: 2, py: 3 }}>
        <Typography variant="h5" sx={{ mb: 0.5 }}>{t('outageJournal')}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2, maxWidth: 760 }}>{t('outageJournalHint')}</Typography>

        {error && <Alert severity="error">{t('outageLoadError')}</Alert>}
        {!error && rows === null && <CircularProgress size={28} />}
        {!error && rows !== null && rows.length === 0 && <Alert severity="success">{t('outageEmpty')}</Alert>}

        {!error && rows !== null && rows.length > 0 && (
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>{t('outageColStart')}</TableCell>
                  <TableCell>{t('outageColEnd')}</TableCell>
                  <TableCell sx={num}>{t('outageColDuration')}</TableCell>
                  <TableCell>{t('outageColReason')}</TableCell>
                  <TableCell sx={num}>{t('outageColDevices')}</TableCell>
                  <TableCell sx={num}>{t('outageColHours')}</TableCell>
                  <TableCell sx={num}>{t('outageColKwh')}</TableCell>
                  <TableCell sx={num}>{t('outageColAmount')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((o) => (
                  <TableRow key={o.id}>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{fmtDateTime(o.started_at)}</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{fmtDateTime(o.ended_at)}</TableCell>
                    <TableCell sx={num}>{t('outageDuration', { hours: Math.floor(o.duration_minutes / 60), minutes: o.duration_minutes % 60 })}</TableCell>
                    <TableCell sx={{ minWidth: 240 }}>{o.reason}</TableCell>
                    <TableCell sx={num}>{t('outageDevices', { working: o.devices_working, total: o.devices })}</TableCell>
                    <TableCell sx={num}>{fmtInt(o.credited_hours)}</TableCell>
                    <TableCell sx={num}>{fmtInt(o.credited_kwh)}</TableCell>
                    <TableCell sx={num}>{fmtInt(o.credited_amount)} ₽</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </Box>
  );
};

export default Outages;
